<mat-toolbar>
	<button mat-icon-button type="button" (click)="drawer().toggle()" aria-label="Close">
		<mat-icon class="app-24">close</mat-icon>
	</button>
	<div class="spacer"></div>
	<button mat-icon-button type="button" [matMenuTriggerFor]="langMenu" i18n-matTooltip="@@drawer-lang-tooltip|Language switcher button tooltip" matTooltip="Cambiar idioma" i18n-aria-label="@@drawer-lang-aria|Language switcher aria-label" aria-label="Cambiar idioma">
		<img [ngSrc]="currentLocale === 'es' ? 'images/icon-spanish-flag.png' : 'images/icon-english-flag.png'" width="24" height="24" [alt]="currentLocale" class="flag-icon">
	</button>
	<mat-menu #langMenu="matMenu">
		<button mat-menu-item type="button" (click)="switchTo('es')" [class.active-locale]="currentLocale === 'es'">
			<div class="language-menu-item">
				<img ngSrc="images/icon-spanish-flag.png" width="24" height="24" alt="ES" class="flag-icon">
				<span class="flag-text">ES</span>
			</div>
		</button>
		<button mat-menu-item type="button" (click)="switchTo('en')" [class.active-locale]="currentLocale === 'en'">
			<div class="language-menu-item">
				<img ngSrc="images/icon-english-flag.png" width="24" height="24" alt="EN" class="flag-icon">
				<span class="flag-text">EN</span>
			</div>
		</button>
	</mat-menu>
	<button mat-icon-button type="button" (click)="appService.toggleDarkTheme()" aria-label="Toggle dark mode" [matTooltip]="appService.theme()==='app-dark-theme' ? 'Light mode' : 'Dark mode'">
		<mat-icon>{{appService.theme()==='app-dark-theme' ? 'light_mode' : 'dark_mode'}}</mat-icon>
	</button>
</mat-toolbar>
<div class="drawer-content">
	<mat-nav-list class="drawer-nav-list">
		<a mat-list-item [routerLink]="['/']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
			<span i18n="@@drawer-home|Home nav link">Inicio</span>
		</a>
		@if (authenticationService.user()) {
			<a mat-list-item [routerLink]="['/profile']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
				<span i18n="@@drawer-profile|My profile nav link">Mi perfil</span>
			</a>
		}
		<a mat-list-item [routerLink]="['/blog']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
			<span i18n="@@drawer-blog|Blog nav link">Blog</span>
		</a>
		<mat-expansion-panel class="app-elevation0" [expanded]="true">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<b i18n="@@drawer-products-section|Products section title">Productos</b>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-nav-list>
				<a mat-list-item [routerLink]="['/products']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
					<span class="app-14" i18n="@@drawer-all-products|All products nav link">Todos los productos</span>
				</a>
				@for (category of appService.productCategories(); track category.id) {
					<a mat-list-item [routerLink]="['/products']" [queryParams]="{category:category.slug}" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
						<span>{{category.label}}</span>
					</a>
				}
			</mat-nav-list>
		</mat-expansion-panel>
		<a mat-list-item [routerLink]="['/tecnicas-modernas-de-cultivo']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
			<span i18n="@@drawer-tecnicas|Modern cultivation techniques nav link">Técnicas modernas de cultivo</span>
		</a>
		<a mat-list-item [routerLink]="['/clasificacion-de-semillas-de-cannabis']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
			<span i18n="@@drawer-semillas|Cannabis seed classification nav link">Clasificación de semillas de cannabis</span>
		</a>
		<a mat-list-item [routerLink]="['/envios']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
			<span i18n="@@drawer-shipping-policy|Shipping policy nav link">Política de envíos</span>
		</a>
		<a mat-list-item [routerLink]="['/contact']" [routerLinkActive]="'tab-active app-elevation1'" [routerLinkActiveOptions]="{exact:true}" (click)="drawer().toggle()">
			<span i18n="@@drawer-contact|Contact nav link">Contacto</span>
		</a>
	</mat-nav-list>
	<div class="drawer-footer-container">
		<div class="drawer-footer">
			<a mat-icon-button class="drawer-footer-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" href="https://wa.me/{{environment.contact.phone.replace('+','')}}" target="_blank" aria-label="Whatsapp">
				<mat-icon aria-label="whatsapp" [svgIcon]="'app-whatsapp'"></mat-icon>
			</a>
			<a mat-icon-button class="drawer-footer-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" [href]="environment.contact.instagram" target="_blank" aria-label="Intagram">
				<mat-icon aria-label="instagram" [svgIcon]="'app-instagram'"></mat-icon>
			</a>
			<a mat-icon-button class="drawer-footer-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" [href]="environment.contact.facebook" target="_blank" aria-label="Facebook">
				<mat-icon aria-label="facebook" [svgIcon]="'app-facebook'"></mat-icon>
			</a>
			<a mat-icon-button class="drawer-footer-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" [href]="environment.contact.x" target="_blank" aria-label="X">
				<mat-icon aria-label="X" [svgIcon]="'app-x'"></mat-icon>
			</a>
		</div>
	</div>
</div>
